module.exports = __webpack_public_path__ + "8ad6bd588f0833c0fc42c8938f14b82e.jpg";